import styled from "styled-components";

export const Button = styled.div`
  position: fixed;
  width: 100%;
  left: 47%;
  bottom: 40px;
  height: 20px;
  font-size: 3rem;
  z-index: 1;
  cursor: pointer;
  color: rgb(3, 56, 58);
  &:hover {
    color: rgb(166, 249, 255);
  }
`;
